/** True when PATCH failed due to optimistic-lock / version mismatch (HTTP 409). */
export function isWorkItemVersionConflictError(error) {
  const status = error?.response?.status ?? error?.status;
  if (status === 409) return true;
  const msg = String(
    error?.message ?? error?.response?.data?.message ?? error?.payload ?? ""
  ).toLowerCase();
  return msg.includes("version") && (msg.includes("mismatch") || msg.includes("conflict"));
}
